<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 13:09:51
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-06-27 16:31:43
 * @Description: 
-->
<!--
 * @Author: Tina Huang
 * @Date: 2023-06-27 13:09:51
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-06-27 14:09:42
 * @Description: 
-->
<template>
  <div class="layout">
    <!-- <img class="circle" src="@/assets/home-bg.png" /> -->
    <div class="site" id="site-header" v-if="!hideHeader">
      <router-link :to="{ name: 'mindex' }" :underline="false">
        <img id="icon" src="@/assets/icon-1.png" />
        <h2>{{ site_name }}</h2></router-link
      >
    </div>
    <div :class="['content', hideHeader ? 'noHeader' : '']">
      <slot></slot>
    </div>
    <p class="footer">©️ 阿汪同学</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      site_name: "Widverse · 汪汪汪世界",
      drawer: false,
      direction: "rtl",
      newUpdate: null,
      centerDialogVisible: false,
      // pathname: this.$route.name,
      // news_update:
    };
  },
  computed: {
    hideHeader() {
      const path = this.$route.name;
      if (path === "mcreate") {
        return true;
      }
      return false;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.layout {
  padding: 20px 0;
}
.site {
  position: fixed;
  text-align: center;
  left: 0;
  right: 0;
  top: 0;
  h2 {
    font-size: 24px;
  }
  #icon {
    width: 80px;
  }
}
.footer {
  text-align: center;
  font-size: 12px;
  padding-top: 20px;
}
.content {
  padding: 120px 0 0 0;
  &.noHeader {
    padding: 0;
  }
}
</style>
